import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/utility/storage/storage.service';
import { AuthenticationService } from 'src/app/service/translate/authentication.service';
import { LoginInput } from 'src/app/models/loginInput.interface';

@Component({
  selector: 'app-videologin',
  templateUrl: '../../login/login.component.html',
  styleUrls: ['./videologin.component.scss'],
})
export class VideologinComponent implements OnInit {
  /**
   * Show password
   */
  hide = true;
  /**
   * Costruttore
   * @param  router Per il redirect
   * @param authenticationService Per chiamate alla login
   * @param storageService Per controllare dati utente in locale
   */
  constructor(
    private router: Router,

    public authenticationService: AuthenticationService,
    private storageService: StorageService
  ) {}
  /**
   * Inizializzo controllando se utente ha un token valido
   */
  ngOnInit() {
    if (this.storageService.getStoredObject('currentUserVideo')) {
      this.router.navigate(['/extra/video'], { queryParamsHandling: 'preserve' });
    }
  }

  /**
   * Login utente
   * @param user Dati utente
   */
  login(user: LoginInput) {
    this.authenticationService.loading = true;
    this.authenticationService.loginVideo(user);
  }
}
